/**
 *
 */
export default class Screen {
	public readonly width = 1024;
	public readonly height = 768;
	public readonly availWidth = 1024;
	public readonly availHeight = 768;
	public readonly colorDepth = 24;
	public readonly pixelDepth = 24;
}
